module.exports = __webpack_public_path__ + "img/Chatapp thumb.3f2a0d68.jpg";